var exports = {
  "U": "xcc377c0b--7911b8--arrow",
};

module.exports = exports;
